document.addEventListener('DOMContentLoaded', (event) => {
    // function fixRadioButtons() {
    //     const wrappers = document.querySelectorAll('.picky-option__wrapper');
        
    //     wrappers.forEach((wrapper, i) => {
    //         const radioGroups = wrapper.querySelectorAll('[role="radiogroup"]');
            
    //         radioGroups.forEach((group, j) => {
    //             const radios = group.querySelectorAll('[role="radio"]');
    //             if (radios.length === 0) return;
                
    //             function updateTabIndexes() {
    //                 const selected = group.querySelector('[aria-checked="true"]') || radios[0];
    //                 radios.forEach(radio => {
    //                     radio.setAttribute('tabindex', radio === selected ? '0' : '-1');
    //                 });
    //             }
                
    //             updateTabIndexes();
                
    //             // Keydown
    //             group.addEventListener('keydown', (e) => {
    //                 const currentRadio = document.activeElement;
    //                 if (!currentRadio || currentRadio.getAttribute('role') !== 'radio') return;
                    
    //                 const radioArray = [...radios];
    //                 const currentIndex = radioArray.indexOf(currentRadio);
    //                 let newIndex = currentIndex;
                    
    //                 switch(e.key) {
    //                     case 'ArrowRight':
    //                     case 'ArrowDown':
    //                         e.preventDefault();
    //                         newIndex = (currentIndex + 1) % radioArray.length;
    //                         break;
    //                     case 'ArrowLeft':
    //                     case 'ArrowUp':
    //                         e.preventDefault();
    //                         newIndex = (currentIndex - 1 + radioArray.length) % radioArray.length;
    //                         break;
    //                     default:
    //                         return;
    //                 }
                    
    //                 const newRadio = radioArray[newIndex];
                    
    //                 currentRadio.setAttribute('tabindex', '-1');
    //                 newRadio.setAttribute('tabindex', '0');
                    
    //                 newRadio.focus();
    //                 newRadio.click();
    //             });
    //         });
            
    //         const observer = new MutationObserver(() => {
    //             const radioGroups = wrapper.querySelectorAll('[role="radiogroup"]');
    //             radioGroups.forEach(group => {
    //                 const radios = group.querySelectorAll('[role="radio"]');
    //                 const selected = group.querySelector('[aria-checked="true"]') || radios[0];
    //                 radios.forEach(radio => {
    //                     radio.setAttribute('tabindex', radio === selected ? '0' : '-1');
    //                 });
    //             });
    //         });
            
    //         observer.observe(wrapper, { 
    //             attributes: true, 
    //             subtree: true, 
    //             attributeFilter: ['aria-checked'] 
    //         });
    //     });
    // }

    function fixRadioButtons() {
        function setPillsAttributes() {
            document.querySelectorAll('.picky-option__pill').forEach(pill => {

                if (pill.getAttribute('role') === 'radiogroup') return;
                
                pill.setAttribute('role', 'radiogroup');
                
                pill.querySelectorAll('.picky-pill__item').forEach(button => {
                    button.setAttribute('role', 'radio');
                });

                const parent = pill.closest('.picky-product-card');
                if(parent) {
                    const observer = new MutationObserver(() => {
                        if(!parent.className.includes('isDeactivated')) {
                            setTimeout(() => {
                                pill.querySelectorAll('.picky-pill__item').forEach(button => {
                                    const isSelected = button.className.includes('_selected');
                                    button.setAttribute('aria-checked', isSelected ? 'true' : 'false');
                                    button.setAttribute('tabindex', isSelected ? '0' : '-1')
                                });
                            }, 500);
                            observer.disconnect();
                        }
                    })

                    observer.observe(parent, {
                        attributes: true,
                        attributeFilter: ['class']
                    });
                }
            });
        }
    
        setPillsAttributes();

        document.querySelectorAll('.picky-option__wrapper').forEach(wrapper => {
            wrapper.querySelectorAll('[role="radiogroup"]').forEach(group => {
                const radios = [...group.querySelectorAll('[role="radio"]')];
                if (!radios.length) return;

                const update = (selected) => {
                    radios.forEach(radio => {
                    radio.tabIndex = radio === selected ? 0 : -1;
                    });
                };

                // init
                update(group.querySelector('[aria-checked="true"]') || radios[0]);

                group.addEventListener('click', e => {
                    const radio = e.target.closest('[role="radio"]');
                    if (!radio) return;
                    update(radio);
                });

                group.addEventListener('keydown', e => {
                    const current = document.activeElement;
                    if (!radios.includes(current)) return;

                    let nextIndex = radios.indexOf(current);

                    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                    e.preventDefault();
                    nextIndex = (nextIndex + 1) % radios.length;
                    }

                    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                    e.preventDefault();
                    nextIndex = (nextIndex - 1 + radios.length) % radios.length;
                    }

                    if (nextIndex === radios.indexOf(current)) return;

                    const next = radios[nextIndex];
                    update(next);
                    next.focus();
                    next.click();
                });
            });
        });
    }


    fixRadioButtons();

    function fixPickyTitles() {
        document.querySelectorAll('.picky-title[role="link"]').forEach(title => {
            title.setAttribute('role', 'button');
            const name = title.getAttribute('aria-label');
            title.setAttribute('aria-label', `Open ${name} modal`);
        });
    }

    fixPickyTitles();

    function fixUpsellAccessibility() {
        const upsell = document.querySelector('.pdp-upsell-v2, pdp-upsell');
        if (!upsell) return;
        
        upsell.setAttribute('role', 'group');

        // Change h3 to h2
        const h3 = upsell.querySelector('.pdp-upsell-v2__heading, .pdp-upsell__heading');
        let heading = h3;
        if (h3 && h3.tagName === 'H3') {
            const h2 = document.createElement('h2');
            h2.className = h3.className;
            h2.textContent = h3.textContent;
            h3.replaceWith(h2);
            heading = h2;
        }

        // Add id and aria-labelledby
        heading.id = 'pdp-upsell-heading';
        upsell.setAttribute('aria-labelledby', 'pdp-upsell-heading');

        // Change image labels to div
        upsell.querySelectorAll('.pdp-upsell-v2__image-label').forEach(label => {
            const div = document.createElement('div');
            div.className = label.className;
            div.innerHTML = label.innerHTML;
            
            label.replaceWith(div);

            const img = div.querySelector('.pdp-upsell-v2__image');
            if (img) img.setAttribute('alt', '');

             // Add click listener to trigger checkbox
            div.addEventListener('click', () => {
                const parent = div.closest('.pdp-upsell-v2__option');
                if (parent) {
                    const titleLabel = parent.querySelector('.pdp-upsell-v2__option-label');
                    if (titleLabel) titleLabel.click();
                }
            });
        });    
    }

    fixUpsellAccessibility();
});